import { Link } from 'react-router-dom';
import { Mail } from 'lucide-react';
import { useConsent } from '@/contexts/ConsentContext';
import { FONT_B, FONT_H, INK } from './theme';

const COLUMNS = [
  {
    heading: 'Product',
    links: [
      { label: 'Pool types', to: '/pool-types' },
      { label: 'Masters pools', to: '/masters-pools' },
      { label: 'vs spreadsheets', to: '/vs-spreadsheets' },
      { label: 'FAQ', to: '/faq' },
    ],
  },
  {
    heading: "Who it's for",
    links: [
      { label: 'Golf societies', to: '/golf-societies' },
      { label: 'Sports clubs', to: '/sports-clubs' },
      { label: 'Bars & pubs', to: '/bars-and-pubs' },
      { label: 'Workplaces', to: '/workplaces' },
      { label: 'Friend groups', to: '/friend-groups' },
    ],
  },
  {
    heading: 'Resources',
    links: [
      { label: 'How to run a sweepstake', to: '/guides/run-a-sweepstake' },
      { label: 'Rules & scoring', to: '/rules' },
      { label: 'Terms of use', to: '/terms' },
      { label: 'Privacy policy', to: '/privacy' },
    ],
  },
];

/* Mobile design: centred logo, one row of links, copyright. */
const MOBILE_LINKS = [
  { label: 'Pool types', to: '/pool-types' },
  { label: 'Golf societies', to: '/golf-societies' },
  { label: 'Sports clubs', to: '/sports-clubs' },
  { label: 'Bars & pubs', to: '/bars-and-pubs' },
  { label: 'Guides', to: '/guides/run-a-sweepstake' },
  { label: 'FAQ', to: '/faq' },
];

export function MarketingFooter() {
  const { openPreferences } = useConsent();
  return (
    <footer style={{ background: INK, color: '#9B8CB8' }} data-testid="marketing-footer">
      {/* Mobile */}
      <div className="md:hidden px-5 pt-7 pb-20 text-center">
        <img src="/brand/landscape-logo-white.png" alt="SportSweeps" className="h-[26px] w-auto mx-auto mb-3" />
        <div className="flex justify-center flex-wrap gap-4 text-xs mb-3.5" style={FONT_B}>
          {MOBILE_LINKS.map((l) => (
            <Link key={l.to} to={l.to} className="hover:text-white transition-colors" data-testid={`marketing-footer-mobile-link${l.to.replace(/\//g, '-')}`}>{l.label}</Link>
          ))}
        </div>
        <div className="flex justify-center flex-wrap gap-4 text-[11px] mb-3" style={FONT_B}>
          <Link to="/terms" className="hover:text-white transition-colors">Terms</Link>
          <Link to="/privacy" className="hover:text-white transition-colors">Privacy</Link>
          <button type="button" onClick={openPreferences} className="hover:text-white transition-colors" data-testid="marketing-footer-mobile-cookie-prefs">Cookies</button>
        </div>
        <p className="text-[11px] m-0" style={FONT_B}>&copy; {new Date().getFullYear()} SportSweeps · GDPR compliant</p>
      </div>

      {/* Desktop */}
      <div className="hidden md:block max-w-[1200px] mx-auto px-8 pt-14 pb-8">
        <div className="grid grid-cols-[1.4fr_1fr_1fr_1fr] gap-10 mb-10">
          <div>
            <img src="/brand/landscape-logo-white.png" alt="SportSweeps" className="h-8 w-auto mb-4" />
            <p className="text-[13px] leading-relaxed max-w-[260px]" style={FONT_B}>
              Run sports pools and sweepstakes for your club, bar, company or group &mdash; no spreadsheets, no chaos.
            </p>
            <a href="mailto:support@sportsweeps.io" className="mt-4 inline-flex items-center gap-1.5 text-[13px] hover:text-white transition-colors" style={FONT_B} data-testid="marketing-footer-email">
              <Mail className="w-3.5 h-3.5" /> support@sportsweeps.io
            </a>
          </div>

          {COLUMNS.map((col) => (
            <div key={col.heading} className="flex flex-col gap-2.5 text-[13px]" style={FONT_B}>
              <span className="text-white font-bold text-sm mb-1" style={FONT_H}>{col.heading}</span>
              {col.links.map((l) => (
                <Link key={l.to} to={l.to} className="hover:text-white transition-colors" data-testid={`marketing-footer-link${l.to.replace(/\//g, '-')}`}>{l.label}</Link>
              ))}
              {col.heading === 'Resources' && (
                <button type="button" onClick={openPreferences} className="text-left hover:text-white transition-colors" data-testid="marketing-footer-cookie-prefs">
                  Cookie preferences
                </button>
              )}
            </div>
          ))}
        </div>

        <div className="pt-6 border-t border-white/10 flex items-center justify-between gap-3 text-[11px]" style={FONT_B}>
          <p>&copy; {new Date().getFullYear()} SportSweeps. All rights reserved.</p>
          <span>GDPR compliant</span>
        </div>
      </div>
    </footer>
  );
}
